const services = [
  { icon: "ri-file-list-3-line", title: "Abertura de Empresa", desc: "LLC ou C-Corp em até 5 dias úteis" },
  { icon: "ri-shield-check-line", title: "Compliance Calendar", desc: "Lembretes automáticos de obrigações" },
  { icon: "ri-map-pin-2-line", title: "Endereço Virtual", desc: "Endereço comercial em Miami, FL" },
  { icon: "ri-bank-line", title: "Abertura de Conta", desc: "Conta bancária nos EUA sem viajar" },
  { icon: "ri-exchange-funds-line", title: "Relatórios Financeiros", desc: "Bookkeeping e contabilidade mensal" },
  { icon: "ri-global-line", title: "Agente Registrado", desc: "Representante legal obrigatório nos EUA" },
  { icon: "ri-user-settings-line", title: "EIN/ITIN", desc: "Número de identificação fiscal nos EUA" },
  { icon: "ri-calendar-check-line", title: "Annual Report", desc: "Relatório anual junto ao estado" },
  { icon: "ri-store-2-line", title: "Endereço Comercial", desc: "Endereço físico para correspondências" },
  { icon: "ri-customer-service-2-line", title: "Suporte em Português", desc: "Time especializado falando português" },
  { icon: "ri-printer-line", title: "Digitalização de Documentos", desc: "Todos os documentos digitalizados" },
  { icon: "ri-headphone-line", title: "Especialista Dedicado", desc: "Especialista exclusivo para sua empresa" },
];

export default function ServicesSection() {
  return (
    <section id="servicos" className="bg-white py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#2563eb] text-sm font-semibold tracking-wider uppercase">O que está incluído</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f2044] mt-2 mb-4">
            Serviços incluídos em{" "}
            <span className="text-[#2563eb]">todos os planos</span>
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            Selecione o que você precisa e customize para o seu negócio. Oferecemos tudo que você precisa para operar com segurança nos EUA.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="group p-5 rounded-2xl border border-gray-100 bg-[#f5f7fc] hover:border-[#2563eb]/40 hover:bg-blue-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#0f2044] group-hover:bg-[#2563eb] rounded-xl mb-3 transition-colors">
                <i className={`${service.icon} text-white text-lg`} />
              </div>
              <h4 className="text-[#0f2044] font-semibold text-sm mb-1">{service.title}</h4>
              <p className="text-gray-500 text-xs leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#precos"
            className="inline-flex items-center gap-2 bg-[#0f2044] hover:bg-[#162d5c] text-white font-semibold px-7 py-3 rounded-full transition-colors cursor-pointer text-sm"
          >
            Ver todos os planos e preços
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
